<script lang="ts">
import { defineComponent } from 'vue';

import useButtonStyle, { buttonStyleProps } from '@/composables/useButtonStyles';

export default defineComponent({
  name: 'ButtonGroup',
  props: {
    ...buttonStyleProps,
  },
  setup(props) {
    const buttonStyles = useButtonStyle(props);

    return {
      ...buttonStyles,
    };
  },
});
</script>

<template>
  <div
    class="flex w-full text-sm border border-gray-300 border-solid rounded-full md:text-base remove-padding"
    :class="[
      borderUtilities,
      cursorUtilities,
      colorUtilities,
      fontSizeUtilities,
      heightUtilities,
      widthUtilities,
    ]"
  >
    <slot name="left" />
    <div
      class="my-3 border-solid buttons-separator"
      :class="theme === 'white' ? 'border-gray-300' : 'border-white'"
    />
    <slot name="right" />
  </div>
</template>

<style scoped>
.remove-padding {
  @apply p-0;
}
.buttons-separator {
  border-right-width: 1.5px;
}
</style>
